import React, { useContext, useState } from 'react'
import { appContext } from "../../AppContext";
import { Form, Input, Button, message, Divider } from 'antd';
import {useFetch} from '../../utils/hooks/useFetch'
import RegisterModal from './RegisterModal';
import { Redirect } from 'react-router';
import {
    Link,
  } from 'react-router-dom';

export default function Login() {
    // eslint-disable-next-line
    const [appState, AppDispatch] = useContext(appContext);
    const [doFetch, FetchType] = useFetch();
    const [isLoading, setIsLoading] = useState(false);

    const [isModalRegisterVisible, setIsModalRegisterVisible] = useState(false);

    function showRegisterModal() {
        setIsModalRegisterVisible(true);
    }

    const layout = {
        labelCol: { span: 2 },
        wrapperCol: { span: 6 },
      };
      const tailLayout = {
        wrapperCol: { offset: 2, span: 6 },
      };

      async function onFinish (values) {
        setIsLoading(true);
        const url = `/api/Account/Login`;
        const body = {
            email:values.userName,
            password:values.password
        }

        doFetch(url, FetchType.POST, body)
            .then((response) => {
                if(response.isSuccess) {
                    AppDispatch({ type: "LOGIN", payload: response.result })
                    setIsLoading(false);
                    return;
                }
                setIsLoading(false);
                message.error('Login failed')
            })
      };

      if(appState.user !== undefined ) {
          return <Redirect to={appState.loginRedirect} />
      }

      return (
          <>
            <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt="Logo"/>
            <Form
                {...layout}
                name="basic"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                >
                <Form.Item
                    label="email"
                    name="userName"
                    rules={[{ required: true, message: 'Please input your email!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit" disabled={isLoading}>
                    Submit
                    </Button>
                </Form.Item>

                <Link to={`/${appState.appName}/forgot-password`}>Forgot password</Link>
                <p>Please make sure your account is verified with an email</p>

                <Divider />
                <Form.Item {...tailLayout}>
                    <Button onClick={showRegisterModal} disabled={isLoading} loading={isLoading}> 
                        Register
                    </Button>
                </Form.Item>
            </Form>


            <RegisterModal 
                setIsModalVisible={setIsModalRegisterVisible}
                isModalVisible={isModalRegisterVisible}
            />
        </>
      )
}